import { render } from "./SezioneHead.vue?vue&type=template&id=4a65b9e0&ts=true"
import script from "./SezioneHead.vue?vue&type=script&lang=ts"
export * from "./SezioneHead.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__